import { useState } from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import UndoIcon from "@mui/icons-material/Undo";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  showClaim: boolean;
  showOwnerActions: boolean;
  onEdit: () => void;
  onClaim: () => void;
  onReturn: () => void;
  onComplete: () => void;
  isBusy: boolean;
}

export function AmbulanzMenu({ showClaim, showOwnerActions, onEdit, onClaim, onReturn, onComplete, isBusy }: Props) {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const close = () => setAnchor(null);
  const runAndClose = (action: () => void) => () => {
    action();
    close();
  };

  return (
    <>
      <IconButton
        size="small"
        disabled={isBusy}
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        aria-label={t("common.options")}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close} onClick={(e) => e.stopPropagation()}>
        <MenuItem onClick={runAndClose(onEdit)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("ambulanzes.actions.edit")}</ListItemText>
        </MenuItem>

        {showClaim && (
          <MenuItem onClick={runAndClose(onClaim)}>
            <ListItemIcon>
              <PersonAddAltIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("ambulanzes.actions.claim")}</ListItemText>
          </MenuItem>
        )}

        {showOwnerActions && (
          <MenuItem onClick={runAndClose(onComplete)}>
            <ListItemIcon>
              <CheckCircleOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("ambulanzes.actions.complete")}</ListItemText>
          </MenuItem>
        )}

        {showOwnerActions && (
          <MenuItem onClick={runAndClose(onReturn)}>
            <ListItemIcon>
              <UndoIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("ambulanzes.actions.return")}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
